import { useRef, useCallback } from 'react';

function useScrollToTop() {
    const scrollContainerRef = useRef(null);

    const scrollToTop = useCallback(() => {
        const scrollOptions = { top: 0, behavior: 'smooth' };
        const focusTarget = scrollContainerRef.current || document.querySelector('main');

        if (focusTarget && typeof focusTarget.focus === 'function') {
            focusTarget.focus({ preventScroll: true });
        }

        if (scrollContainerRef.current) {
            try {
                scrollContainerRef.current.scrollTo(scrollOptions);
            } catch (e) {
                scrollContainerRef.current.scrollTop = 0;
            }
        }

        const mainEl = document.querySelector('main');
        if (mainEl) {
            try {
                mainEl.scrollTo(scrollOptions);
            } catch (e) {
                mainEl.scrollTop = 0;
            }
        }

        try {
            window.scrollTo(scrollOptions);
        } catch (e) {
            window.scrollTo(0, 0);
        }
    }, []);

    return [scrollContainerRef, scrollToTop];
}

export default useScrollToTop;